package games.polyclub.website.frontend.store.sitemap

import games.polyclub.frontend.lib.react.bootstrap.css.utility.BootstrapVerticalAlign
import games.polyclub.frontend.lib.react.bootstrap.css.utility.BootstrapVerticalAlign.Companion.bVerticalAlign
import games.polyclub.frontend.lib.react.simplified.SimplifiedChildrenBuilder
import games.polyclub.frontend.lib.react.simplified.tags.*
import js.core.jso
import web.cssom.Height
import web.cssom.Width

data class Icon(
    val src: String,
    val type: Type = Type.FONT_AWESOME,
    val width: Width? = null,
    val height: Height? = null,
) {
    fun SimplifiedChildrenBuilder.renderIcon(classes: String = "") = when (type) {
        Type.FONT_AWESOME -> i("$classes fa $src") {
            bVerticalAlign = BootstrapVerticalAlign.MIDDLE
        }
        Type.FONT_AWESOME_SOLID -> i("$classes fas $src") {
            bVerticalAlign = BootstrapVerticalAlign.MIDDLE
        }
        Type.URL -> img(classes) {
            width = width?.toString()?.takeIf { it.endsWith("px") }?.removePrefix("px")?.toDoubleOrNull()
            height = height?.toString()?.takeIf { it.endsWith("px") }?.removePrefix("px")?.toDoubleOrNull()
            style = jso {
                width = this@Icon.width
                height = this@Icon.height
            }
            src = this@Icon.src
        }
    }

    enum class Type {
        FONT_AWESOME,
        FONT_AWESOME_SOLID,
        URL
    }

    companion object {
        fun fa(icon: String) = Icon(icon)
        fun fas(icon: String) = Icon(icon, Type.FONT_AWESOME_SOLID)
        fun src(src: String, width: Width? = null, height: Height? = null) = Icon(src, Type.URL, width, height)
    }
}
